import React from 'react';
import Locale from '../domain/Locale';
import Currency from '../domain/Currency';
import Amount from '../domain/Amount';
import Shipping from '../domain/Shipping';
import get_bundle from '../domain/get_bundle';
import MarkdownComponent from './MarkdownComponent';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  currency: Currency,
  shipping: Shipping,
  omit_country: t.Bool
})
export default class StdShipping extends React.Component {

  getCountry() {
    if (!this.props.shipping.country || this.props.omit_country) {
      return null;
    }

    const countryLabel = get_bundle(this.props.locale).order.shippings.country;
    return (
      <span>
        {countryLabel}
        &nbsp;
        <strong>
          {this.props.locale.display_country(this.props.shipping.country)}
        </strong>
      </span>
    );
  }

  getCost() {
    return Amount.format(this.props.locale, this.props.currency, this.props.shipping.cost);
  }

  getDescription() {
    return this.props.shipping.description;
  }

  render() {
    return (
      <div>
        <p>{this.getCountry()}</p>
        <p>
          <MarkdownComponent>
           {this.getCost()}
          </MarkdownComponent>
          &nbsp;
          &nbsp;
          <MarkdownComponent>
            {this.getDescription()}
          </MarkdownComponent>
        </p>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/StdShipping.js
 **/